import { Table, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { Edit2 } from 'iconsax-react'
import { AdminsEcommerceGetProductCategoryItem, UserRoleEnum } from 'generated/api'
import { thousandSeparator } from 'helpers/numbers'

export interface PropsCategoriesTable {
  data: AdminsEcommerceGetProductCategoryItem[]
  loading: boolean
  onClickDetail: (category: AdminsEcommerceGetProductCategoryItem) => void
}

export default function CategoriesTable(props: PropsCategoriesTable) {
  const getPoint = (role: UserRoleEnum, data: AdminsEcommerceGetProductCategoryItem) => {
    const point =
      (data.rolePointUsageItems &&
        data.rolePointUsageItems.find(item => item.role === role)?.maxPointUsage) ||
      0
    return point ? `${thousandSeparator(point)}%` : '-'
  }

  const columnsCategory: ColumnsType<AdminsEcommerceGetProductCategoryItem> = [
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">No.</Typography.Text>
        </div>
      ),
      width: '5%',
      dataIndex: 'nomor',
      key: 'nomor',
      render: (_, _row, index) => (
        <div className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{index + 1}.</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nama Kategori</Typography.Text>
        </div>
      ),
      width: '15%',
      dataIndex: 'name',
      key: 'name',
      render: name => (
        <div className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{name}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex justify-center">
          <Typography.Text className="font-semibold text-gray-800">
            % Penggunaan Poin
          </Typography.Text>
        </div>
      ),
      children: [
        {
          title: 'Semua',
          dataIndex: 'maxPointUsage',
          key: 'maxPointUsage',
          width: '10%',
          render: maxPointUsage => (
            <div className="flex flex-col">
              <Typography.Text className="font-medium text-gray-800">
                {thousandSeparator(maxPointUsage)}%
              </Typography.Text>
            </div>
          ),
        },
        {
          title: 'Agen',
          width: '10%',
          render: (_, row) => {
            return (
              <div className="flex flex-col">
                <Typography.Text className="font-medium text-gray-800">
                  {getPoint(UserRoleEnum.Agent, row)}
                </Typography.Text>
              </div>
            )
          },
        },
        {
          title: 'Kordinator Lapangan',
          width: '10%',
          render: (_, row) => {
            return (
              <div className="flex flex-col">
                <Typography.Text className="font-medium text-gray-800">
                  {getPoint(UserRoleEnum.FieldCoordinator, row)}
                </Typography.Text>
              </div>
            )
          },
        },
        {
          title: 'Supir',
          width: '10%',
          render: (_, row) => {
            return (
              <div className="flex flex-col">
                <Typography.Text className="font-medium text-gray-800">
                  {getPoint(UserRoleEnum.Driver, row)}
                </Typography.Text>
              </div>
            )
          },
        },
        {
          title: 'Petani',
          width: '10%',
          render: (_, row) => {
            return (
              <div className="flex flex-col">
                <Typography.Text className="font-medium text-gray-800">
                  {getPoint(UserRoleEnum.Farmer, row)}
                </Typography.Text>
              </div>
            )
          },
        },
        {
          title: 'Pemanen',
          width: '10%',
          render: (_, row) => {
            return (
              <div className="flex flex-col">
                <Typography.Text className="font-medium text-gray-800">
                  {getPoint(UserRoleEnum.Harvester, row)}
                </Typography.Text>
              </div>
            )
          },
        },
      ],
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Aksi</Typography.Text>
        </div>
      ),
      width: '5%',
      dataIndex: 'action',
      key: 'action',
      render: (_, category) => {
        return (
          <Edit2
            data-testid="action-to-edit-category"
            size="16"
            color="#3C5337"
            className="hover:cursor-pointer"
            onClick={() => props.onClickDetail(category)}
          />
        )
      },
    },
  ]

  return (
    <Table
      rowKey="id"
      loading={props.loading}
      data-testid="table-category-product"
      className="table-categories sticky-table-header"
      columns={columnsCategory}
      dataSource={props.data}
      pagination={false}
    />
  )
}
